import { formatAmount } from "./Utils";

export const formatSentStatsAmount = (amount: number): string => {
  if (amount < 100000) {
    return formatAmount(amount);
  }

  if (amount < 1000000) {
    const valueInK = Math.floor((amount / 1000) * 10) / 10;
    const compact = formatAmount(valueInK);
    return `${compact}K`;
  }

  const valueInM = Math.floor((amount / 1000000) * 10) / 10;
  const compact = formatAmount(valueInM);
  return `${compact}M`;
};

